module.exports = require("./pt-BR.js");